module.exports = __webpack_public_path__ + "img/Group 15.f49090c5.svg";